import { createSelector } from '@reduxjs/toolkit';
import { selfClientSelector } from './self';

const selectedLimitSelector = createSelector(selfClientSelector, (clients) => clients.selectedLimit);

export default selectedLimitSelector;
